import { entities } from "../../src/i18n"

type Entity = { id: string | number; name?: string }
type Messages = Record<string, (ctx?: unknown) => string>

export type FormatEntity = (value: Entity) => string
export type FormatKey = (key: string) => string

/** Load the given language's entity labels, return format helpers. */
export const LoadFormat = async (lang: string) => {
  const messages = (await entities[lang as keyof typeof entities]?.()) as Messages
  const format_entity: FormatEntity = value => {
    const key = String(value.name ?? value.id)
    return messages[key]?.(value) ?? key
  }
  const format_key: FormatKey = key => messages[key]?.() ?? key
  return { format_entity, format_key }
}
